import React, { Component } from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 py-16 border-t border-gray-800" data-id="element-195">
      <div className="container mx-auto px-4 md:px-6" data-id="element-196">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-197">
          {/* Brand */}
          <div data-id="element-198">
            <div className="flex items-center gap-3 mb-6" data-id="element-199">
              <img src="https://cdn.magicpatterns.com/uploads/dSUoJFewu2oS1dagyRHpgT/IconOnly.png" alt="Plastic Engineering Solutions Logo" className="h-10 w-auto object-contain" data-id="element-200" />
              <span className="text-white font-bold text-lg" data-id="element-201">
                Plastic Engineering Solutions
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-202">
              Your trusted partner for medical device components and packaging.
              Delivering precision, quality, and reliability since 2024.
            </p>
          </div>

          {/* Contact */}
          <div data-id="element-203">
            <h3 className="text-white font-bold mb-6" data-id="element-204">Contact Info</h3>
            <ul className="space-y-4" data-id="element-205">
              <li className="flex items-start gap-3" data-id="element-206">
                <MapPin className="h-5 w-5 text-accent mt-0.5" data-id="element-207" />
                <span data-id="element-208">
                  Based in Saratoga Springs, Utah
                  <br data-id="element-209" />
                  Serving Clients Nationwide
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-210">
                <Phone className="h-5 w-5 text-accent" data-id="element-211" />
                <a href="tel:+18016186677" className="hover:text-white transition-colors" data-id="element-212">
                  (801) 618-6677
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-213">
                <Mail className="h-5 w-5 text-accent" data-id="element-214" />
                <a href="mailto:parker@plastices.com" className="hover:text-white transition-colors" data-id="element-215">
                  parker@plastices.com
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-216">
            <h3 className="text-white font-bold mb-6" data-id="element-217">Services</h3>
            <ul className="space-y-3 text-sm" data-id="element-218">
              <li data-id="element-219">
                <a href="#process" className="hover:text-accent transition-colors" data-id="element-220">
                  Injection Molding Process
                </a>
              </li>
              <li data-id="element-221">
                <a href="#expertise" className="hover:text-accent transition-colors" data-id="element-222">
                  Medical Device Components
                </a>
              </li>
              <li data-id="element-223">
                <a href="#expertise" className="hover:text-accent transition-colors" data-id="element-224">
                  Dietary Supplement Packaging
                </a>
              </li>
              <li data-id="element-225">
                <a href="#materials" className="hover:text-accent transition-colors" data-id="element-226">
                  Material Consultation
                </a>
              </li>
              <li data-id="element-227">
                <a href="#partnership" className="hover:text-accent transition-colors" data-id="element-228">
                  Quality Assurance
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-sm text-gray-500" data-id="element-229">
          <p data-id="element-230">
            &copy; {new Date().getFullYear()} Plastic Engineering Solutions. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}